import { UserParticipant } from "./UserParticipant";

export class ReportingLineParticipant extends UserParticipant {
    reportingLineDefId: string;
    reportingLineDefName: string;
    refOrgId: string;
    refOrgName: string;
    refUserId: string;
    refEmployeeId: string;
    dimension: string;
    reportingReferObject: string;
}